require("core-js/modules/es6.regexp.replace");

var digest = require('./digest');

function parseData(_email) {
  var _query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!(typeof _email === 'string' || typeof _email === 'object' && typeof _email.email === 'string')) throw Error("'email' is required in 'gatsby-source-gravatar'.");
  var email = typeof _email === 'string' ? _email : _email.email;
  var hash = digest(email);
  var query = typeof _email === 'object' ? _email.query : _query || null;
  return {
    url: "https://www.gravatar.com/avatar/".concat(hash).concat(query ? "?".concat(query.replace(/^\?/, '')) : ""),
    email: email,
    hash: hash,
    query: query
  };
}

module.exports = parseData;